import { getRenterApplication } from 'app/sm/renter_applications/renter_applications_access'

type ApplicationWithFormCapabilities = {
  formCapabilities?: unknown
  [key: string]: unknown
}

export const loadApplicationFormCapabilities = (
  applicationGUID: string,
  application: ApplicationWithFormCapabilities,
): Promise<ApplicationWithFormCapabilities> => {
  // Always fetches managersummary on modal open — GET /sm/applications/:id does not
  // return formCapabilities, so the one-time per-open cost is unavoidable here.
  return getRenterApplication(applicationGUID).then(
    ({
      ok,
      application: summary,
      responseText,
    }: {
      ok: boolean
      application?: ApplicationWithFormCapabilities
      responseText?: Promise<string> | string
    }) => {
      if (!ok) {
        return Promise.resolve(responseText).then((error) =>
          Promise.reject(error),
        )
      }

      return { ...application, formCapabilities: summary?.formCapabilities }
    },
  )
}
